// extracted by mini-css-extract-plugin
export var borderRadius = "_ff-4";
export var large = "_ff-3";
export var logoContainer = "_ff-0";
export var nameLogo = "_ff-2";
export var small = "_ff-1";